import { useAgentFieldCreateAgentFieldCreatePostMutation } from '@shared/api';
import type { CreateAgentFieldValues } from '../lib/types';

export const useCreateField = () => {
  const [createFieldMutation, { isLoading }] = useAgentFieldCreateAgentFieldCreatePostMutation();

  const createField = async (agentId: number, values: CreateAgentFieldValues) => {
    try {
      const normalizedFilter = values.filter.map((item) => item.trim()).filter(Boolean);
      await createFieldMutation({
        agentId,
        createAgentField: {
          name: values.name,
          description: values.description,
          filter: normalizedFilter,
          alias: values.alias,
          is_required: values.isRequired,
          is_active: values.isActive,
        },
      }).unwrap();
    } catch (e) {}
  };

  return {
    createField,
    isLoading,
  };
};
